import type { SelectDropdownRichOption } from '../../../library/editors/elements/select-dropdown-rich-option';
import { t } from 'src/i18n';

export const sectorOptions: SelectDropdownRichOption[] = [
  {
    value: 'HEALTH',
    text: t('features.sectorOptions.health.text'),
    secondaryText: t('features.sectorOptions.health.secondaryText'),
  },
  {
    value: 'CRAFTS_TRANSPORTATION_CLEANING',
    text: t('features.sectorOptions.craftsTransportationCleaning.text'),
    secondaryText: t('features.sectorOptions.craftsTransportationCleaning.secondaryText'),
  },
  {
    value: 'FOOD_ACCOMMODATION',
    text: t('features.sectorOptions.foodAccommodation.text'),
    secondaryText: t('features.sectorOptions.foodAccommodation.secondaryText'),
  },
  {
    value: 'PERSONAL_TRADE_SERVICE',
    text: t('features.sectorOptions.personalTradeService.text'),
    secondaryText: t('features.sectorOptions.personalTradeService.secondaryText'),
  },
  {
    value: 'OFFICE',
    text: t('features.sectorOptions.office.text'),
    secondaryText: t('features.sectorOptions.office.secondaryText'),
  },
  {
    value: 'OTHER',
    text: t('features.sectorOptions.other.text'),
    secondaryText: '',
  },
];
